import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { RecipientListInterface } from '../types/recipient-list';
import {
  RecipientListFilter,
  defaultRecipientListFilter,
} from '../types/recipient-list-filter';

export const RECIPIENT_LIST_STATE = 'recipientList';

export interface RecipientListState {
  filter: RecipientListFilter;
  dataSource: DataSource<RecipientListInterface[]>;
}

export const initialDataSource: DataSource<RecipientListInterface[]> =
  Object.freeze({
    ...initialPageableData,
    rawData: [],
  });

export const initialRecipientListState: RecipientListState = Object.freeze({
  filter: defaultRecipientListFilter,
  dataSource: {
    ...initialDataSource,
  },
});
